import React from 'react';

import { FlagName } from '@zapier/design-system-revenue/src/types';
import { flags } from './flags';

type FlagIconProps = {
  /** The flag to display. */
  name: FlagName;
  /** The width of the icon. */
  width?: number;
};

/**
 * An icon representing a country's flag.
 */
export const FlagIcon = ({ name, width = 36 }: FlagIconProps) => {
  const Flag = flags[name];
  return <Flag width={width} />;
};
